import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CareerNodeTooltip from './CareerNodeTooltip'
import EducationNodeTooltip from './EducationNodeTooltip'
import InitialNodeTooltip from './InitialNodeTooltip'
import applicationConstants from '../../../../../../utils/constants/application'

const { CAREER, EDUCATION, INITIAL } = applicationConstants.wheel_chart_node_type

class WheelChartTooltip extends Component {
  static propTypes = {
    activeNode: PropTypes.any,
  }

  render() {

  	const { activeNode } = this.props
    if (activeNode && activeNode.type){
      switch (activeNode.type){
        case CAREER:
          return <CareerNodeTooltip {...this.props} />
        case EDUCATION:
          return <EducationNodeTooltip {...this.props} />
        case INITIAL:
          return <InitialNodeTooltip {...this.props} />
        default :
          return null
      }
    }
    return <div/>
  }
}

export default WheelChartTooltip



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/components/WheelChartTooltip.js